import React, { useEffect, useState, useRef } from 'react';
import N3rveLogo from "./../../images/N3rveLogo.png"
import NavbarDesc from "./../../images/navbar_desc.png"
import Cross from "./../../images/crossicon.png"
import NavbarCross from "./../../images/navbar_cross.png"
import EnIcon from "./../../images/englishicon.png"
import JapIcon from "./../../images/japanicon.png"
import NavbarTranslate from "./../../images/navbar_translate.png"
import LoginBtn from "./../../images/navloginbtn.png"
import SignBtn from "./../../images/navsignupbtn.png"
import { Link, useNavigate, useLocation } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next'
import i18next from "i18next"
import FAQPlusIcon from './../../images/faqplusicon.png'
import PurpleFlower from './../../images/purpleflower.png'
import FAQMinusIcon from './../../images/faqminusicon.png'
import Footer from '../Footer/Footer';
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from '../Helpers/LogToWix';
import { useJwt, decodeToken } from "react-jwt";

function FAQ() {
    const [FAQ1, setFAQ1] = useState(false);
    const [FAQ2, setFAQ2] = useState(false);
    const [FAQ3, setFAQ3] = useState(false);
    const [FAQ4, setFAQ4] = useState(false);
    const [FAQ5, setFAQ5] = useState(false);
    const [FAQ6, setFAQ6] = useState(false);
    const [FAQ7, setFAQ7] = useState(false);
    const [FAQ8, setFAQ8] = useState(false);
    const [FAQ9, setFAQ9] = useState(false);
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const { t, i18n } = useTranslation();
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    const cookies = new Cookies(null, { path: '/' });
    const hasLogged = useRef(false);

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const handleResize = () => {
        // console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    useEffect(() => {
        topFunction()
        window.addEventListener("resize", handleResize, false);

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "FAQ Page", { "desc": "User opened the faq page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "FAQ Page", { "desc": "User opened the faq page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "FAQ Page", { "desc": "User opened the faq page" })
                hasLogged.current = true;
            }
        }


    }, []);

    return (
        <div style={{ height: dimensions.height, overflowY: 'scroll', overflowX: 'hidden' }}>
            {/* ******************************************** */}


            {/* DESKTOP VIEW */}

            {
                dimensions.width >= 1024 &&
                <div style={{
                    backgroundColor: '#1B1B22',
                    // height:'50.68em',
                    width: '100%',
                    height: dimensions.height,
                    backgroundSize: 'cover',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    zIndex: '1',
                    paddingBottom: '10em',
                }}>
                    <img src={PurpleFlower} style={{ width: '30.93em', height: '31.16em', position: 'absolute', zIndex: '0', top: '0em', left: '0em' }} />
                    <div className="LandingPgDiv8H2" style={{ zIndex: '1', width: '67.78%' }}>
                        {t('Faqs')}
                    </div>

                    {/* <div className="FAQ1">
                          <div className="FAQ" style={{borderTop:'2px #131317 solid',cursor:'pointer'}}>
                          What is N3RVE?
                              <div className="FAQDesc">
                                  N3RVEs stands as an alternative to conventional labels, catering to independent artists. We offer top-tier music distribution services and forge exclusive collaborations between artists and global giants. Our package includes data analytics, potent marketing tools, promotional support, and creative services, all designed to nurture artist fanbases across their journey. Unlike the traditional label model, N3RVE ensures artists maintain total control over their careers and music master recordings. With substantial investor interest and a diverse artist lineup, N3RVEs redefines the indie music landscape.
                              </div>
                          </div>
                  </div> */}
                    <div style={{ display: 'flex', flexDirection: 'column', width: '67.78%', justifyContent: 'flex-start', zIndex: '1' }}>


                        {
                            !FAQ1 &&
                            <div className="FAQ" style={{ borderTop: '2px #FFFFFF solid', cursor: 'pointer' }} onClick={() => { setFAQ1(!FAQ1); setFAQ2(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }}>
                                {t('Whatisnervefaq')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ1 &&
                            <div onClick={() => setFAQ1(!FAQ1)} style={{ zIndex: '1' }}>
                                <div className="FAQ" style={{ borderTop: '2px #FFFFFF solid', cursor: 'pointer' }}>
                                    {t('Whatisnervefaq')}
                                    <div className="FAQDesc">
                                        {t('N3rvestandsasanalt')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ2 &&
                            <div className="FAQ" onClick={() => { setFAQ2(!FAQ2); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('Whatisdigital')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ2 &&
                            <div onClick={() => setFAQ2(!FAQ2)} style={{ zIndex: '1' }}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('Whatisdigital')}
                                    <div className="FAQDesc">
                                        {t('Digitalmusicdistreferstotheprocess')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ3 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(!FAQ3); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('Howdoidistributemymusic')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ3 &&
                            <div onClick={() => setFAQ3(!FAQ3)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('Howdoidistributemymusic')}
                                    <div className="FAQDesc">
                                        {t('Atnerveweofferyouastraight')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ4 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(!FAQ4); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('Whatmusicdoesnerveaccept')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ4 &&
                            <div onClick={() => setFAQ4(!FAQ4)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('Whatmusicdoesnerveaccept')}
                                    <div className="FAQDesc">
                                        {t('Atnerveweofferyouastraight')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ5 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(!FAQ5); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('Whatformatshouldiprepare')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ5 &&
                            <div onClick={() => setFAQ5(!FAQ5)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('Whatformatshouldiprepare')}
                                    <div className="FAQDesc">
                                        {t('Weacceptmusicinthexxx')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ6 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(!FAQ6); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('doiownmymasterwithnerve')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ6 &&
                            <div onClick={() => setFAQ6(!FAQ6)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('doiownmymasterwithnerve')}
                                    <div className="FAQDesc">
                                        {t('yesnerveenablesartists')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ7 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(!FAQ7); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('whichplanisforme')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ7 &&
                            <div onClick={() => setFAQ7(!FAQ7)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('whichplanisforme')}
                                    <div className="FAQDesc">
                                        {t('weprovidethreetiers')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ8 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(!FAQ8); setFAQ9(false) }} style={{ cursor: 'pointer' }}>
                                {t('howdoireceivepaymentsformymusic')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ8 &&
                            <div onClick={() => setFAQ8(!FAQ8)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('howdoireceivepaymentsformymusic')}
                                    <div className="FAQDesc">
                                        {t('Whendisttributingmusicthroughnerve')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }

                        {
                            !FAQ9 &&
                            <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(!FAQ9) }} style={{ cursor: 'pointer' }}>
                                {t('whyisnervebetter')}
                                <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        }

                        {
                            FAQ9 &&
                            <div onClick={() => setFAQ9(!FAQ9)}>
                                <div className="FAQ" style={{ cursor: 'pointer' }}>
                                    {t('whyisnervebetter')}
                                    <div className="FAQDesc">
                                        {t('Tryusandfindout')}
                                    </div>
                                    <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                                </div>
                            </div>
                        }
                    </div>

                </div>
            }


            {/* ******************************************** */}


            {/* TABLET VIEW */}

            {
                dimensions.width >= 768 && dimensions.width < 1024 &&
                <div style={{
                    backgroundColor: '#1B1B22',
                    //  height:'50.68em',
                    width: dimensions.width,
                    backgroundSize: 'cover',
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'white',
                    paddingBottom: '10em',
                    position: 'relative'
                }}>
                    <img src={PurpleFlower} style={{ width: '30.93em', height: '31.16em', position: 'absolute', zIndex: '0', top: '0em', left: '-2em' }} />
                    <div className="LandingPgDiv8H2" style={{ marginLeft: '1em' }}>
                        {t('Faqs')}
                    </div>

                    {/* <div className="FAQ1">
                      <div className="FAQ" style={{borderTop:'2px #131317 solid',cursor:'pointer'}}>
                      What is N3RVE?
                          <div className="FAQDesc">
                              N3RVEs stands as an alternative to conventional labels, catering to independent artists. We offer top-tier music distribution services and forge exclusive collaborations between artists and global giants. Our package includes data analytics, potent marketing tools, promotional support, and creative services, all designed to nurture artist fanbases across their journey. Unlike the traditional label model, N3RVE ensures artists maintain total control over their careers and music master recordings. With substantial investor interest and a diverse artist lineup, N3RVEs redefines the indie music landscape.
                          </div>
                      </div>
              </div> */}

                    {
                        !FAQ1 &&
                        <div className="FAQ" style={{ borderTop: '2px #FFFFFF solid', cursor: 'pointer', marginLeft: '1.5em', width: '80%' }} onClick={() => { setFAQ1(!FAQ1); setFAQ2(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }}>
                            {t('Whatisnervefaq')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ1 &&
                        <div onClick={() => setFAQ1(!FAQ1)}>
                            <div className="FAQ" style={{ borderTop: '2px #FFFFFF solid', cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('Whatisnervefaq')}
                                <div className="FAQDesc">
                                    {t('N3rvestandsasanalt')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ2 &&
                        <div className="FAQ" onClick={() => { setFAQ2(!FAQ2); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('Whatisdigital')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ2 &&
                        <div onClick={() => setFAQ2(!FAQ2)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('Whatisdigital')}
                                <div className="FAQDesc">
                                    {t('Digitalmusicdistreferstotheprocess')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ3 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(!FAQ3); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('Howdoidistributemymusic')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ3 &&
                        <div onClick={() => setFAQ3(!FAQ3)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('Howdoidistributemymusic')}
                                <div className="FAQDesc">
                                    {t('Atnerveweofferyouastraight')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ4 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(!FAQ4); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('Whatmusicdoesnerveaccept')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ4 &&
                        <div onClick={() => setFAQ4(!FAQ4)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('Whatmusicdoesnerveaccept')}
                                <div className="FAQDesc">
                                    {t('Atnerveweofferyouastraight')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ5 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(!FAQ5); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('Whatformatshouldiprepare')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ5 &&
                        <div onClick={() => setFAQ5(!FAQ5)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('Whatformatshouldiprepare')}
                                <div className="FAQDesc">
                                    {t('Weacceptmusicinthexxx')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ6 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(!FAQ6); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('doiownmymasterwithnerve')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ6 &&
                        <div onClick={() => setFAQ6(!FAQ6)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('doiownmymasterwithnerve')}
                                <div className="FAQDesc">
                                    {t('yesnerveenablesartists')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ7 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(!FAQ7); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('whichplanisforme')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ7 &&
                        <div onClick={() => setFAQ7(!FAQ7)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('whichplanisforme')}
                                <div className="FAQDesc">
                                    {t('weprovidethreetiers')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ8 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(!FAQ8); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('howdoireceivepaymentsformymusic')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ8 &&
                        <div onClick={() => setFAQ8(!FAQ8)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('howdoireceivepaymentsformymusic')}
                                <div className="FAQDesc">
                                    {t('Whendisttributingmusicthroughnerve')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ9 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(!FAQ9) }} style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                            {t('whyisnervebetter')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ9 &&
                        <div onClick={() => setFAQ9(!FAQ9)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '1.5em', width: '80%' }}>
                                {t('whyisnervebetter')}
                                <div className="FAQDesc">
                                    {t('Tryusandfindout')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }


                </div>
            }



            {/* ******************************************** */}


            {/* MOBILE VIEW */}

            {
                dimensions.width < 768 &&
                <div style={{
                    backgroundColor: '#1B1B22',
                    //  height:'60.68em',
                    paddingBottom: '5em',
                    paddingLeft: '1em',
                    width: '95vw',
                    backgroundSize: 'cover',
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'white',
                    position: 'relative'
                }}>
                    <img src={PurpleFlower} style={{ width: '30.93em', height: '31.16em', position: 'absolute', zIndex: '0', top: '0em', left: '-2em' }} />
                    <div className="LandingPgDiv8H2" style={{ marginLeft: '0em' }}>
                        {t('Faqs')}
                    </div>

                    {/* <div className="FAQ1">
                          <div className="FAQ" style={{borderTop:'2px #131317 solid',cursor:'pointer'}}>
                          What is N3RVE?
                              <div className="FAQDesc">
                                  N3RVEs stands as an alternative to conventional labels, catering to independent artists. We offer top-tier music distribution services and forge exclusive collaborations between artists and global giants. Our package includes data analytics, potent marketing tools, promotional support, and creative services, all designed to nurture artist fanbases across their journey. Unlike the traditional label model, N3RVE ensures artists maintain total control over their careers and music master recordings. With substantial investor interest and a diverse artist lineup, N3RVEs redefines the indie music landscape.
                              </div>
                          </div>
                  </div> */}

                    {
                        !FAQ1 &&
                        <div className="FAQ" style={{ borderTop: '2px #FFFFFF solid', cursor: 'pointer', width: '90%', marginLeft: '0em' }} onClick={() => { setFAQ1(!FAQ1); setFAQ2(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }}>
                            {t('Whatisnervefaq')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ1 &&
                        <div onClick={() => setFAQ1(!FAQ1)}>
                            <div className="FAQ" style={{ borderTop: '2px #FFFFFF solid', cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('Whatisnervefaq')}
                                <div className="FAQDesc">
                                    {t('N3rvestandsasanalt')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ2 &&
                        <div className="FAQ" onClick={() => { setFAQ2(!FAQ2); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('Whatisdigital')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ2 &&
                        <div onClick={() => setFAQ2(!FAQ2)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('Whatisdigital')}
                                <div className="FAQDesc">
                                    {t('Digitalmusicdistreferstotheprocess')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ3 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(!FAQ3); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('Howdoidistributemymusic')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ3 &&
                        <div onClick={() => setFAQ3(!FAQ3)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('Howdoidistributemymusic')}
                                <div className="FAQDesc">
                                    {t('Atnerveweofferyouastraight')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ4 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(!FAQ4); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('Whatmusicdoesnerveaccept')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ4 &&
                        <div onClick={() => setFAQ4(!FAQ4)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('Whatmusicdoesnerveaccept')}
                                <div className="FAQDesc">
                                    {t('Atnerveweofferyouastraight')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ5 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(!FAQ5); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('Whatformatshouldiprepare')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ5 &&
                        <div onClick={() => setFAQ5(!FAQ5)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('Whatformatshouldiprepare')}
                                <div className="FAQDesc">
                                    {t('Weacceptmusicinthexxx')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ6 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(!FAQ6); setFAQ7(false); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('doiownmymasterwithnerve')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ6 &&
                        <div onClick={() => setFAQ6(!FAQ6)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('doiownmymasterwithnerve')}
                                <div className="FAQDesc">
                                    {t('yesnerveenablesartists')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ7 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(!FAQ7); setFAQ8(false); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('whichplanisforme')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ7 &&
                        <div onClick={() => setFAQ7(!FAQ7)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('whichplanisforme')}
                                <div className="FAQDesc">
                                    {t('weprovidethreetiers')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ8 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(!FAQ8); setFAQ9(false) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('howdoireceivepaymentsformymusic')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ8 &&
                        <div onClick={() => setFAQ8(!FAQ8)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('howdoireceivepaymentsformymusic')}
                                <div className="FAQDesc">
                                    {t('Whendisttributingmusicthroughnerve')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }

                    {
                        !FAQ9 &&
                        <div className="FAQ" onClick={() => { setFAQ2(false); setFAQ1(false); setFAQ3(false); setFAQ4(false); setFAQ5(false); setFAQ6(false); setFAQ7(false); setFAQ8(false); setFAQ9(!FAQ9) }} style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                            {t('whyisnervebetter')}
                            <img src={FAQPlusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                        </div>
                    }

                    {
                        FAQ9 &&
                        <div onClick={() => setFAQ9(!FAQ9)}>
                            <div className="FAQ" style={{ cursor: 'pointer', marginLeft: '0em', width: '90%' }}>
                                {t('whyisnervebetter')}
                                <div className="FAQDesc">
                                    {t('Tryusandfindout')}
                                </div>
                                <img src={FAQMinusIcon} style={{ width: '1em', height: '1em', right: '2em', top: '1.2em', position: 'absolute' }} />
                            </div>
                        </div>
                    }


                </div>
            }

            <Footer />
        </div>
    )
}

export default FAQ;